import React from 'react';
import { motion } from 'framer-motion';
import { Users, Shield, Sparkles, Key, BookOpen } from 'lucide-react';
import './UpgradePanel.css';

interface UpgradePanelProps {
  planLabel: string;
  onUpgrade: () => void;
}

const UNLOCK_FEATURES = [
  {
    icon: Users,
    title: '2 Seats Included',
    desc: 'Invite another rep to collaborate in your workspace.',
  },
  {
    icon: Key,
    title: 'Per-Seat Credits',
    desc: 'Each team member gets their own dedicated 2,700 monthly credits.',
  },
  {
    icon: BookOpen,
    title: 'Team Battlecards',
    desc: 'Share cards and best-plays across all members.',
  },
];

export function UpgradePanel({ planLabel, onUpgrade }: UpgradePanelProps) {
  return (
    <motion.div
      className="upgrade-panel"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.4, 0, 0.2, 1] }}
    >
      {/* Left column */}
      <div className="upgrade-panel__left">
        <span className="upgrade-panel__badge">
          <Sparkles size={11} />
          Upgrade required
        </span>

        <h2 className="upgrade-panel__heading">
          Unlock Team<br />Collaboration
        </h2>

        <p className="upgrade-panel__body">
          You're on the {planLabel} with 105 credits included. Upgrade to the Team plan to collaborate, share credits, and unlock team-wide battlecards.
        </p>

        <div className="upgrade-panel__actions">
          <button className="upgrade-panel__btn-primary" onClick={onUpgrade}>
            <Sparkles size={14} />
            Upgrade Plan
          </button>
        </div>

        <div className="upgrade-panel__trust">
          <span><span className="upgrade-panel__trust-check">✓</span> No credit card required</span>
          <span><span className="upgrade-panel__trust-check">✓</span> Cancel anytime</span>
        </div>
      </div>

      {/* Right column */}
      <div className="upgrade-panel__right">
        <p className="upgrade-panel__right-label">What you'll unlock</p>
        <div className="upgrade-panel__features">
          {UNLOCK_FEATURES.map((f, i) => (
            <motion.div
              key={f.title}
              className="upgrade-feature-card"
              initial={{ opacity: 0, x: 16 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: 0.1 + i * 0.06, ease: [0.4, 0, 0.2, 1] }}
            >
              <div className="upgrade-feature-card__icon">
                <f.icon size={16} />
              </div>
              <div>
                <p className="upgrade-feature-card__title">{f.title}</p>
                <p className="upgrade-feature-card__desc">{f.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.div>
  );
}
